import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const ImageMarquee = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api
      .get("/drop")
      .then((r) => setItems(r.data || []))
      .catch(() => setItems([]));
  }, []);

  if (!items.length) return null;

  // Alternate tees with non-tees so tees don't sit next to each other
  const isTee = (i) =>
    /tee/i.test(i.name || "") || (i.category || "").toUpperCase() === "TOP" && /tee/i.test(i.name || "");
  const tees = items.filter(isTee);
  const others = items.filter((i) => !isTee(i));
  const interleaved = [];
  const maxLen = Math.max(tees.length, others.length);
  for (let i = 0; i < maxLen; i++) {
    if (i < tees.length) interleaved.push(tees[i]);
    if (i < others.length) interleaved.push(others[i]);
  }

  // Duplicate for seamless loop
  const loop = [...interleaved, ...interleaved];

  return (
    <section
      data-testid="image-marquee"
      className="relative overflow-hidden border-b border-[#333] bg-white py-6"
    >
      <div className="flex marquee-track items-center gap-6 whitespace-nowrap pl-6">
        {loop.map((item, i) => (
          <figure
            key={`${item.id}-${i}`}
            className="flex shrink-0 items-center gap-3"
          >
            <img
              src={item.image}
              alt={item.name}
              className="h-24 w-20 border border-black/10 object-cover md:h-28 md:w-24"
              draggable={false}
            />
            <figcaption className="flex flex-col text-black">
              <span className="font-mono-stamp text-[9px] text-black/50">
                DESIGN {item.design_no}
              </span>
              <span
                className="font-logo text-sm md:text-base"
                style={{ letterSpacing: "0.08em" }}
              >
                {item.name.toUpperCase()}
              </span>
            </figcaption>
            <span className="mx-2 font-mono-stamp text-[10px] text-black/30">
              ▸▸▸
            </span>
          </figure>
        ))}
      </div>
    </section>
  );
};
